import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { createFieldGroupAction } from "../../../../../modules/fieldgroups/action";
import "../../../../../style";
import FieldGroupForm from "./FieldGroupForm";


class CreateFieldGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successMessage: "",
      errorMessage: {}
    };
  }

  handleSubmit = fieldGroupInfo => {
    fieldGroupInfo.name = fieldGroupInfo.name.trim();
    this.props.createFieldGroupAction(fieldGroupInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.fieldGrpCreated && nextProps.fieldGrpCreated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/farmsetup/farminformation/field-groups" />;
    }
    return (
      <FieldGroupForm
        buttonLabel="Add new field group"
        formLabel="Set up your field group"
        handleSubmit={this.handleSubmit}
        MainFarmId={this.props.MainFarmId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    fieldGrpCreated: state.fieldGroupReducer.fieldGrpCreated,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createFieldGroupAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateFieldGroup);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/CreateFieldGroup.js